import classNames from 'classnames'
import './styles/panel-range-input-styles.css'
import { InputHTMLAttributes, forwardRef } from 'react'

interface PanelInputProps extends InputHTMLAttributes<HTMLInputElement> {
  defaultValue?: InputHTMLAttributes<HTMLInputElement>['defaultValue']
  title?: string
}

const PanelRangeInput = forwardRef<HTMLInputElement, PanelInputProps>(function PanelInput ({ title, defaultValue, ...rest }, ref) {
  return (
    <div>
      {
        title && (
          <h3 className="font-semibold text-[14px] text-gray-900 mb-2">
            {title}
          </h3>
        )
      }
      <input
        {...rest}
        ref={ref}
        type="range"
        defaultValue={defaultValue}
        className={classNames(
          'range-input h-1 w-full cursor-pointer appearance-none rounded-full bg-gray-100',
          '[&::-webkit-slider-thumb]:h-4 [&::-webkit-slider-thumb]:w-4 [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:rounded-full',
          'focus:outline-black outline-offset-4',
        )}
      />
    </div>
  )
})

export default PanelRangeInput
